import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SbClientComponent } from './sb-client.component';
import { SbClientRoutingModule } from './sb-client-routing.module';


@NgModule({
  declarations: [
    SbClientComponent
  ],
  imports: [
    CommonModule,
    SbClientRoutingModule
  ]
})
export class SbClientModule { }
